export class OrderModel {

  constructor({ payment_id, plan, is_active, deactivated_at, paid_at, expires_in} = {}) {
    this.payment_id = payment_id;
    this.plan = plan;
    this.is_active = is_active;
    this.deactivated_at = deactivated_at;
    this.paid_at = paid_at;
    this.expires_in = expires_in;
  }
}
